import {createApp} from 'vue'
import FrivilligeCheckoutStepOne from './FrivilligeCheckoutStepOne'

const el = '.kb-component--frivillige-checkout-step-one'

export default function(Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((FrivilligeCheckoutStepOneDOM) => {
            const props = {
                fields: FrivilligeCheckoutStepOneDOM.dataset.fields
                    ? JSON.parse(FrivilligeCheckoutStepOneDOM.dataset.fields)
                    : {}
            }
            const component = createApp(FrivilligeCheckoutStepOne, props).use(Store)
            component.mount(FrivilligeCheckoutStepOneDOM)
        })
    }
}